import React, { Suspense } from 'react';
import { isRunningOnClientSide } from '../../../../../utils/func';
import { useSelector } from 'react-redux';
import { usePermissions } from '../../../../../context/PermissionsContext';
import { Redirect } from 'react-router-dom';

const Editor = React.lazy( () => import('./Editor.jsx') );
import ErrorBoundary from '../../../../../components/errorBoundary/ErrorBoundary';

const EditorAsync = ( { props } ) => {
    const permissions = usePermissions();
    if (permissions && !permissions.includes('quiz_content_edit') && !permissions.includes('quiz_graphics_edit')) {
        return <Redirect to='/401' />;
    }
    const { localization: { content } } = useSelector( state => state );

    if ( isRunningOnClientSide() ) {
        return (
            <ErrorBoundary>
                <Suspense fallback={ <div>{ content.loading }</div> }>
                    <Editor { ...props }/>
                </Suspense>
            </ErrorBoundary>
        );
    } else return null;
};

export default EditorAsync;
